
import { Options, Vue } from 'vue-class-component';
import Json2Table from './components/Json2Table.vue';

@Options({
  components: {
    HelloWorld: Json2Table,
  },
})
export default class App extends Vue {}
